<template>
    <div class="flex w-full h-7 rounded-md overflow-hidden">
        <div
            v-for="(segment, i) in segments"
            :key="i"
            class="flex items-center justify-center details font-medium"
            :class="[segment.colorClass, segment.textColorClass]"
            :style="{ width: segment.percent + '%' }"
            :title="`${i + 1}: ${formatNumber(segment.count)} (${formatNumber(segment.percent / 100, 'percent')})`">
            <span v-if="segment.percent >= 6">{{ formatNumber(segment.percent / 100, "percent") }}</span>
        </div>
        <div v-if="totalCount === 0" class="flex-1 bg-surface-sunken"></div>
    </div>
</template>

<script setup lang="ts">
import { formatNumber } from "~vue/utils/formatNumber";
import { computed } from "vue";

import { paletteColor } from "./distributionPalette";

interface Props {
    distribution: number[];
    maxScore?: number | null;
}

const props = defineProps<Props>();

const totalCount = computed(() => props.distribution.reduce((a, b) => a + b, 0));

const segments = computed(() => {
    const total = props.distribution.length;
    return props.distribution.map((count, i) => ({
        count,
        percent: totalCount.value > 0 ? (count / totalCount.value) * 100 : 0,
        colorClass: paletteColor(i, total),
        // Labels follow the swatch, not its position. Pink-600 needs black in both themes.
        textColorClass: /(?:grey|pink-(?:200|600)|blue-200)/.test(paletteColor(i, total)) ? "text-black" : "text-white",
    }));
});
</script>
